
import { KeyValue } from "../key-value";
import { Vehicle } from "./vehicle";

export class Purchase {
    id: number;
	date: Date;
    expedient: string;
    purchasePrice: number;
	amountPaid: number;
    active:boolean;
    transportType:string;
    providers: Array<KeyValue>;
    vehicles: Array<Vehicle>;
    isSale: boolean;
    administrativeFileType: KeyValue;
    administrativeFileStatus: KeyValue;
    office: KeyValue;
    entity: KeyValue;
    shipmentCostType: KeyValue;
    isActive: boolean;
    frame:string;
    buyExpedients: string[];
    createdAt: Date;
    name: string;
    linkedAdminFiles: Array<KeyValue>;
    profit: number; // Sin costes de broker
    profitTransport: number;
    profitVehicles: number;
    amountCollected: number;
    salePrice: number;
    totalSalePrice: number;
    totalPurchasePrice: number;
    purchasePriceNoVAT: number;
    salePriceNoVAT: number;
    shipmentManagementTypeId: number;
    isNewCustomer: boolean;
    isClosed: boolean;
    isDocumentationSent: boolean;
    saleDate: Date | string;
    documentsRemarks: string;
    remarks: string;
    showTransport: boolean;
    costAmount: number;
    crvId?: number;
    hasVehicleInvoice?: boolean;
    availabilityDate?: string | null;
    paymentForecastDate?: Date | string | null;
    depositPayable?: number | null;
    payablePriceAssignmentType?: number | null;
    depositRequested?: number | null;
    requestedPriceAssignmentType?: number | null;

    constructor(purchase) {
        this.id = purchase.id;
        this.date = purchase.date;
        this.expedient= purchase.expedient;
        this.purchasePrice = purchase.purchasePrice;
        this.salePrice = purchase.salePrice;
        this.amountPaid = purchase.amountPaid;
        this.amountCollected = purchase.amountCollected;
        this.active = purchase.active;
        this.providers = purchase.providers;
        this.vehicles = purchase.vehicles?.reduce((list, current) => {
            if (!list.some(x => x.vehicleVersion?.id == current.vehicleVersion?.id)) {
                let total = purchase.vehicles?.filter(x => x.vehicleVersion?.id == current.vehicleVersion?.id).length;
                if(current.vehicleVersion.name == "")
                    current.vehicleVersion.name == "Sin asignar";
                if(total > 1)
                    current.vehicleVersion.name = current.vehicleVersion.name + ' (' + total +')';
                list.push(current);
            }
            return list;
        }, []);
       //  purchase.vehicles?.map(lp => lp.vehicleVersion?.name);
        this.transportType = purchase.transportType;
        this.isSale = purchase.isSale;
        this.administrativeFileType = purchase.administrativeFileType;
        this.administrativeFileStatus = purchase.administrativeFileStatus;
        this.entity = purchase.entity;
        this.office = purchase.office;
        this.shipmentCostType = purchase.shipmentCostType;
        this.isActive = purchase.isActive;
        this.createdAt= purchase.createdAt;
        this.name= purchase.name;
        
        this.buyExpedients = purchase.buyExpedients;
        this.frame = purchase.frame;
        this.linkedAdminFiles = purchase.linkedAdminFiles;
        this.costAmount = purchase.costAmount;
        this.profitTransport = purchase.salePriceTransportNoVat - purchase.purchasePriceTransportNoVat;
        this.profitVehicles = purchase.salePriceVehicleNoVat - purchase.purchasePriceVehicleNoVat - purchase.costAmount;
        this.profit =  this.profitTransport + this.profitVehicles;
        this.totalPurchasePrice =  (purchase.amountPaid - purchase.amountCollected) < 0 ? 0 : purchase.amountPaid - purchase.amountCollected;
        this.totalSalePrice =  (purchase.amountCollected - purchase.amountPaid) < 0 ? 0 :purchase.amountCollected - purchase.amountPaid;
        this.remarks = purchase.remarks;
        this.documentsRemarks = purchase.documentsRemarks;
        this.shipmentManagementTypeId = purchase.shipmentManagementTypeId ?? 1;
        this.isNewCustomer = purchase.isNewCustomer;
        this.isClosed = purchase.isClosed ?? false;
        this.isDocumentationSent = purchase.isDocumentationSent ?? false;
        this.saleDate = purchase.saleDate;
        this.showTransport = !purchase.showTransport;
        this.hasVehicleInvoice = purchase.hasVehicleInvoice;
        this.availabilityDate = purchase.availabilityDate ?? null;
        this.paymentForecastDate          = purchase.paymentForecastDate ?? null;
        this.depositPayable               = purchase.depositPayable ?? null;
        this.payablePriceAssignmentType   = purchase.payablePriceAssignmentType ?? null;
        this.depositRequested             = purchase.depositRequested ?? null;
        this.requestedPriceAssignmentType = purchase.requestedPriceAssignmentType ?? null;
      }
}
  
